import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import MediaQuery from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../utils';

interface Props {
	icon: React.ReactNode;
	directionLabel?: string;
	timePeriod: string;
	description: string;
	className?: string;
	empty?: boolean;
}

const ServicesGroup: React.FC<Props> = props => {
	const theme = useTheme('ServiceAggregation').ServicesGroup;

	return (
		<div className={cn(theme.group, props.className)}>
			<div className={theme.group__description}>
				<div className={theme.timeline}>
					<div className={theme.icon}>{props.icon}</div>

					<div>
						<div className={theme.direction}>{props.directionLabel}</div>
						<div className={theme.time}>{props.timePeriod}</div>
					</div>
				</div>

				{!props.empty && (
					<MediaQuery minWidth={MOBILE_MIN_WIDTH}>
						<div className={theme.description}>{props.description}</div>
					</MediaQuery>
				)}
			</div>

			{!props.empty && <div className={theme.services}>{props.children}</div>}

			{props.empty && <div className={theme.empty}>{props.description}</div>}
		</div>
	);
};

export default ServicesGroup;
